/**
 * A plan's colour slot by id, as a function that changes whenever the
 * renderer learns a slot (planTones.ts): a chip drawn from a task's plan id
 * before the plans arrived takes the plan's own colour when they do, and a
 * memo that depends on the function recomputes.
 */
import { useCallback, useSyncExternalStore } from 'react';

import { planColorsVersion, planToneOf, subscribePlanColors } from './planTones.ts';

export type PlanToneOf = (planId: string, colorIndex?: number) => number;

export function usePlanTone(): PlanToneOf {
  const version = useSyncExternalStore(subscribePlanColors, planColorsVersion, planColorsVersion);
  return useCallback(
    (planId: string, colorIndex?: number) => {
      void version; // a new function per learnt slot
      return planToneOf(planId, colorIndex);
    },
    [version],
  );
}
